export default {
  alert: null,
};
